import { render, staticRenderFns } from "./HistoryBack.vue?vue&type=template&id=2f9de8b7&scoped=true"
import script from "./HistoryBack.vue?vue&type=script&lang=js"
export * from "./HistoryBack.vue?vue&type=script&lang=js"
import style0 from "./HistoryBack.vue?vue&type=style&index=0&id=2f9de8b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9de8b7",
  null
  
)

export default component.exports